<script setup></script>
<template>
	<section class="about" id="about">
		<div class="about__container">
			<picture class="about__image">
				<source media="(max-width: 480px)" srcset="@/assets/img/about/about_img_480.webp 1x, @/assets/img/about/about_img_480@2x.webp 2x" />
				<source media="(max-width: 1024px)" srcset="@/assets/img/about/about_img_1024.webp 1x, @/assets/img/about/about_img_1024@2x.webp 2x" />
				<img class="full-img" width="720" height="656" src="@/assets/img/about/about_img.webp" srcset="@/assets/img/about/about_img@2x.webp 2x" alt="изображение" />
			</picture>
			<div class="about__content">
				<div class="about__header">
					<h2 class="about__title title2">Андрей Шмаков</h2>
					<h3 class="about__subtitle">Бренд-шеф ресторана Savva, бара «Шаляпин», отеля «Метрополь», владелец закусочной «Шмак».</h3>
				</div>
				<div class="about__desc">
					<p>
                        Андрей Шмаков стал бренд-шефом отеля «Метрополь» в 2013 году. До этого он успел поработать на пассажирских лайнерах Европы и в ресторанах Таллина — Le Bonaparte, 
                        Ribe а также в отелях Grand Hotell и Radisson SAS, был шеф-поваром престижного ресторана Kadriorg в одноименном историческом дворце в 
                        Таллинне и «Лапландии» в Санкт-Петербурге — одного из первых ресторанов новой нордической кухни в России.
					</p>
					<p>В 2015-2017 годах Андрей был ведущим всемирно известного<br> проекта «Мастер Шеф Дети» на канале СТС.</p>
					<p>В 2021 году был удостоен премии «ШЕФ-ПОВАР ГОДА», ежегодной российской премии среди шеф-поваров, организованной международным форумом <nobr>«ЗАВТРАк ШЕФА»</nobr>.</p>
					<p>Ресторан SAVVA был удостоен звезды MICHELIN в Гиде MICHELIN 2022. Данная награда имеет большую ценность, так как Москва стала первым городом СНГ, рестораны которого были отмечены от Гиде.</p>
				</div>				
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.about {
	background-color: var(--red);
}
.about__container {
	display: flex;
	align-items: center;
	gap: 6rem;
    width: 76%;
    margin: 0 auto;
    @media (max-width: vars.$lg) {
        width: 100%;
    }
    @media (max-width: vars.$t) {
        flex-direction: column;
        gap: 0;
    }
}
.about__image {
    width: 50%;
    flex-shrink: 0;
    @media (max-width: vars.$t) {
        width: 100%;
    }
}
.about__content {
	max-width: 53rem;
    padding: 1rem 0px;
    @media (max-width: vars.$lg) {
        padding: 1rem var(--padding-container) 1rem 0;
    }
    @media (max-width: vars.$t) {
        padding: 5.6rem var(--padding-container) 8rem;
        max-width: 100%;
    }
    @media (max-width: vars.$x480) {
        padding: 2.5rem var(--padding-container) 3.2rem;
    }
}
.about__header {
	margin-bottom: 5rem;
    @media (max-width: vars.$x480) {
        margin-bottom: 3rem;
    }
}
.about__title {
    @media (max-width: vars.$x480) {
        margin-bottom: 1.3rem;
    }
}

.about__subtitle {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 125%;
	color: var(--white);
    @media (max-width: vars.$x480) {
        font-size: 1.8rem;
    }
}
.about__desc {
	font-weight: 400;
	font-size: 1.4rem;
	line-height: 130%;
	color: var(--white);
  
    @media (max-width: vars.$t) {
      
    }
	p {
		&:not(:last-child) {
			margin-bottom: 1.7rem;
            @media (max-width: vars.$x480) {
                margin-bottom: 1.3rem;
            }
		}
	}
    br {
        @media (max-width: vars.$t) {
            display: none;
        }
    }
}

</style>
